<template>
  <div class="ct-form-rows icap-grid">
    <div
      v-for="(section, sectionIdx) in sections"
      :key="section.title"
      class="ct-section-group"
    >
      <div class="ct-section-head">
        {{ section.title }}
      </div>
      <div
        v-for="(item, itemIdx) in section.items"
        :key="item.var"
        class="ct-item-row icap-card"
        :class="{
          'has-value': answers[item.var] !== null && answers[item.var] !== '',
          'ct-guide-blink': isGuideActive(sectionIdx, itemIdx),
        }"
      >
        <div class="icap-card-main">
          <div class="ct-icap-label" :title="item.label">{{ item.label }}</div>
          <div class="ct-choice-row">
            <button
              v-for="v in 4"
              :key="v - 1"
              type="button"
              class="ct-choice"
              :class="{ active: answers[item.var] === v - 1 }"
              @mousedown="onChoiceInteract"
              @click="setAnswer(item.var, v - 1)"
            >
              {{ v - 1 }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ICAP2_SECTIONS, createIcap2Defaults } from "../data/icap2Sections";
import { submitCorrection, createCorrectionPayload } from "@/services/testCorrectionAdapter";

export default {
  name: "IcapForm",
  inject: {
    corregirTestWorkspace: { default: null },
  },
  props: {
    testValue: { type: Number, required: true },
    age: { type: String, default: "" },
    initialAnswers: { type: Object, default: null },
  },
  data() {
    return {
      sections: ICAP2_SECTIONS,
      answers: createIcap2Defaults(),
      corrected: false,
      loading: false,
    };
  },
  created() {
    this.hydrate(this.initialAnswers);
  },
  computed: {
    toolbarLabel() {
      return "Corregir test";
    },
    toolbarDisabled() {
      return this.loading || this.corrected;
    },
  },
  watch: {
    toolbarLabel: { immediate: true, handler: "emitToolbarMeta" },
    toolbarDisabled: { immediate: true, handler: "emitToolbarMeta" },
    loading: { handler: "emitToolbarMeta" },
  },
  methods: {
    emitToolbarMeta() {
      this.$emit("toolbar-meta", {
        label: this.toolbarLabel,
        disabled: this.toolbarDisabled,
        loading: this.loading,
      });
    },
    setAnswer(varName, value) {
      this.$set(this.answers, varName, value);
      this.corrected = false;
    },
    isGuideActive(sectionIdx, itemIdx) {
      const ws = this.corregirTestWorkspace;
      return ws && sectionIdx === 0 && itemIdx === 0 && ws.isFieldGuideActive(1);
    },
    onChoiceInteract() {
      const ws = this.corregirTestWorkspace;
      if (ws && ws.dismissFieldGuide) ws.dismissFieldGuide();
    },
    buildPayload() {
      const out = {};
      Object.keys(this.answers).forEach((key) => {
        out[key] = String(this.answers[key]);
      });
      return out;
    },
    // Inversa de buildPayload: RedPsi guarda todo como string, y el template
    // compara con === contra números, así que hay que devolverlos a número o
    // ninguna alternativa aparecería marcada.
    hydrate(stored) {
      if (!stored) return;
      Object.keys(this.answers).forEach((key) => {
        const raw = stored[key];
        if (raw == null || raw === "") return;
        const num = Number(raw);
        if (!Number.isNaN(num)) this.$set(this.answers, key, num);
      });
    },
    async submit() {
      if (this.toolbarDisabled) return;
      this.loading = true;
      try {
        const data = await submitCorrection(
          createCorrectionPayload({
            testValue: this.testValue,
            answers: this.buildPayload(),
          })
        );
        this.corrected = true;
        this.$emit("corrected", data);
      } catch (err) {
        const msg =
          (err && err.message) ||
          "No se pudo corregir ICAP. Revisa los datos.";
        if (this.$toasted) this.$toasted.error(msg);
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.answers = createIcap2Defaults();
      this.corrected = false;
      this.loading = false;
    },
  },
};
</script>
